<template>
  <div>
    <nav-bar />
    <v-container fluid>
      <v-row align-content="space-around">
        <v-col cols="12">
          <v-tabs show-arrows grow>
            <v-tab>Time based scheduling</v-tab>
            <v-tabs-slider></v-tabs-slider>
            <v-tab-item>
              <time-based-mqtt></time-based-mqtt>
            </v-tab-item>
            <v-tab>Event based scheduling</v-tab>
            <v-tabs-slider></v-tabs-slider>
            <v-tab-item>
              <event-based-mqtt></event-based-mqtt>
            </v-tab-item>
          </v-tabs>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import NavBar from '../components/NavBar';
import TimeBasedMqtt from '../components/TimeBasedMqtt';
import EventBasedMqtt from '../components/EventBasedMqtt';

export default {
  name: 'schedule-mqtt',
  components: {
    NavBar,
    TimeBasedMqtt,
    EventBasedMqtt
  }
};
</script>
